import { type Placement, type VirtualElement } from '@floating-ui/react-dom'
import { createContext } from 'react'

interface PopperContextType {
  anchor: HTMLElement | VirtualElement | null;
  arrow: HTMLElement | null;
  content: HTMLElement | null;
  placement: Placement | null;
  setAnchor: (elem: HTMLElement | VirtualElement | null) => void;
  setArrow: (elem: HTMLElement | null) => void;
  setContent: (elem: HTMLElement | null) => void;
  setPlacement: (placement: Placement | null) => void;
}

interface ArrowContextType {
  side: 'top' | 'bottom' | 'left' | 'right';
  x: number | undefined;
  y: number | undefined;
}

export const PopperContext = createContext<PopperContextType>({
  anchor: null,
  arrow: null,
  content: null,
  placement: null,
  setAnchor: () => {},
  setArrow: () => {},
  setContent: () => {},
  setPlacement: () => {},
})

export const ArrowContext = createContext<ArrowContextType>({
  side: 'bottom',
  x: undefined,
  y: undefined,
})
